import axios from "axios";

import router from "../router/index.ts";

export const TOKEN_TYPE = "Bearer";
export const ACCESS_TOKEN = "accessToken";
export const REFRESH_TOKEN = "refreshToken";
export const AUTH_HEADER = "Authorization";
export const REFRESH_TOKEN_URL = "/refresh-token";

const axiosIns = axios.create({
  baseURL: import.meta.env.VITE_API_URL ? `${import.meta.env.VITE_API_URL}/api` : "/api",
});

let refreshTokenPromise: Promise<any> | null = null;

axiosIns.interceptors.request.use((config) => {
  const accessToken = localStorage.getItem(ACCESS_TOKEN);

  if (accessToken) {
    config.headers.set(AUTH_HEADER, `${TOKEN_TYPE} ${accessToken}`);
  }
  return config;
}, (error) => Promise.reject(error));

axiosIns.interceptors.response.use((response) => {
  return response;
}, (error) => {
  const { config, response } = error;
  const status = response?.status;
  const originalRequest = config;

  if (status === 401 && !originalRequest._retry) {
    originalRequest._retry = true;

    if (refreshTokenPromise) {
      return refreshTokenPromise.then(() => axiosIns(originalRequest));
    }

    refreshTokenPromise = axiosIns.post(REFRESH_TOKEN_URL, {
      refreshToken: localStorage.getItem(REFRESH_TOKEN),
    }).then(({ data }) => {
      if (data?.accessToken) {
        localStorage.setItem(ACCESS_TOKEN, data.accessToken);
        axiosIns.defaults.headers.common[AUTH_HEADER] = `${TOKEN_TYPE} ${data.accessToken}`;
        return data.accessToken;
      }
      else {
        throw new Error("No access token received");
      }
    }).catch((err) => {
      localStorage.removeItem(ACCESS_TOKEN);
      localStorage.removeItem(REFRESH_TOKEN);
      if (router.currentRoute.value.name !== "login") {
        router.push({ name: "login" });
      }
      throw err?.message ? err : new Error("Authentication failed");
    }).finally(() => {
      refreshTokenPromise = null;
    });

    return refreshTokenPromise.then(() => axiosIns(originalRequest));
  }

  return Promise.reject(error);
});

export default axiosIns;
